import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function Protected(props) {
  const { Component } = props;
  const navigate = useNavigate();
  const login = localStorage.getItem('loggedInUser');

  useEffect(() => {
    if (!login) {
      window.confirm("Please Login First in Homepage");
      navigate('/'); // Navigate to the login page directly
    }
  }, [navigate, login]);

  if (!login) {
    return null;
  }

  return (
    <Component />
  );
}

export default Protected;
